import React, { useState, useCallback, useRef } from 'react'
import _ from 'lodash'

import { Input, Tabs, TextArea } from  '../../../components'
import required from '../../../common/validators/required'

import copy from './copy.svg'

import S from './styled'

const Translates = ({ locales, model: currentModel }) => {
  const [tab, setTab ] = useState((locales[0] || {}).name)

  const { text, model, onChange } = currentModel

  const pluralEl = useRef(null)

  const currentLocaleIndex = _.findIndex(locales, locale => locale.name === tab)
  const currentLocale = locales[currentLocaleIndex]
  const copyField = useCallback(() => {
    pluralEl.current.focus()
    onChange({
      target: {
        name: `values.translates.${currentLocale.id}.pluralNames.many`,
        value: _.get(model, `values.translates.${currentLocale.id}.pluralNames.one`, ''),
      },
    })
  }, [currentLocale, model, onChange])

  return (
    <div>
      <Tabs
        onChange={newPage => setTab(newPage)}
        selected={tab}
        tabs={locales.map(locale => ({ label: locale.name, value: locale.name }))}
        inverted
      >
        <S.TranslatesBlock>
          <S.TranslatesDetails>
            <S.InputsLine>
              <Input {...{
                name: `values.translates.${currentLocale.id}.pluralNames.one`,
                text,
                title: 'Ingredient Name SINGULAR',
                validate: required,
                inverted: true,
              }}
              />
              <img src={copy} alt="copy" onClick={copyField}/>
              <Input {...{
                name: `values.translates.${currentLocale.id}.pluralNames.many`,
                text,
                title: 'Ingredient Name PLURAL',
                validate: required,
                ref: pluralEl,
                inverted: true,
              }}
              />
            </S.InputsLine>
            <S.InputsLine>
              <TextArea {...{
                name: `values.translates.${currentLocale.id}.description`,
                text,
                title: 'Text for Preparation Steps',
                rows: 8,
                validate: required,
                inverted: true,
              }}
              />
            </S.InputsLine>
          </S.TranslatesDetails>
          <S.TranslatesDetailsAdditional>
            <Input {...{
              name: `values.translates.${currentLocale.id}.wiki`,
              text,
              title: 'Wiki Link',
              inverted: true,
            }}
            />
          </S.TranslatesDetailsAdditional>
        </S.TranslatesBlock>
      </Tabs>
    </div>
  )
}

export default Translates
